<ng-container *ngIf="tracker">
  <h5 class="mb-2">{{'lang.globals.status' | translate}}</h5>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <span class="text-dark-75 font-weight-bolder">
      <sb-icon *ngIf="tracker?.disabled" icon="success" class="green"></sb-icon>
      <sb-icon *ngIf="!tracker?.disabled" icon="error" class="grey"></sb-icon>
      {{'lang.globals.disabled' | translate}}
    </span>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <span class="text-dark-75 font-weight-bolder">
      <sb-icon *ngIf="tracker?.productive" icon="success" class="green"></sb-icon>
      <sb-icon *ngIf="!tracker?.productive" icon="error" class="grey"></sb-icon>
      {{'lang.globals.productive' | translate}}
    </span>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <span class="text-dark-75 font-weight-bolder">
      <sb-icon *ngIf="!tracker?.offline" icon="success" class="green"></sb-icon>
      <sb-icon *ngIf="tracker?.offline" icon="error" class="grey"></sb-icon>
      {{'lang.globals.online' | translate}}</span>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <span class="text-dark-75 font-weight-bolder">
      <sb-icon *ngIf="tracker?.external" icon="success" class="green"></sb-icon>
      <sb-icon *ngIf="!tracker?.external" icon="error" class="grey"></sb-icon>
      {{'lang.globals.external' | translate}}
    </span>
  </div>
</ng-container>
